const firebaseConfig = {
    apiKey: "AIzaSyAJudMw7FbGmkpgc9t-VEnMTkRcuRYZn6A",
    authDomain: "doctors-portal-bd88b.firebaseapp.com",
    projectId: "doctors-portal-bd88b",
    storageBucket: "doctors-portal-bd88b.appspot.com",
    messagingSenderId: "194727928068",
    appId: "1:194727928068:web:7104ce353a9f33fe773051",
    measurementId: "G-12R4F5W1ZE"
  };
  export default firebaseConfig;